import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import TextInputBase from "../TextInputContainer";
import { StyledTextArea } from "./TextArea.styles";
import { TextAreaProps } from "./TextArea.types";

const TextArea: FC<TextAreaProps> = ({ className, value, ...props }) => {
	const block = new BemIt("TextArea");

	const hasValue = value && value.toString().length > 0 ? true : false;

	return (
		<TextInputBase
			className={addClass(className).after(block)}
			value={value}
			{...props}
		>
			<StyledTextArea hasValue={hasValue} />
		</TextInputBase>
	);
};

export default TextArea;
